import { computed, inject, Injectable } from '@angular/core';
import { TenantState } from './tenant-state.service';

@Injectable({ providedIn: 'root' })
export class TenantFacadeService {
  private readonly _tenantState = inject(TenantState);

  public tenantApiPrefix = computed(
    () => this._tenantState.currentTenant()?.environmentConfig.appPrefix,
  );
  public tenantApiUrl = computed(
    () => this._tenantState.currentTenant()?.environmentConfig.api,
  );
  public tenantEventNavigationPaths = computed(
    () => this._tenantState.currentTenant()?.eventNavigationPaths,
  );

  public currentTenantKey = computed(
    () => this._tenantState.currentTenant()?.key,
  );
}
